import React, { createContext, useContext } from 'react';
import { useDisclosure } from '@mantine/hooks';
import SuitabilityFlow from './SuitabilityFlow';
import { v4 } from 'uuid';
import { Mixpanel } from 'src/tracking/mixpanel/Mixpanel';
import { MixpanelEvents } from 'src/tracking/mixpanel/MixpanelEvents';

type SuitabilityContextType = {
  opened: boolean;
  flowId: string;
  open: () => void;
  close: () => void;
};

const SuitabilityContext = createContext<SuitabilityContextType>({} as SuitabilityContextType);

export function useSuitability() {
  const context = useContext(SuitabilityContext);
  if (context === undefined) {
    throw new Error('useSuitability must be used within a SuitabilityProvider');
  }
  return context;
}

export default function SuitabilityProvider({ children }: { children: React.ReactNode }) {
  const [opened, { open, close }] = useDisclosure(false);
  const [flowId, setFlowId] = React.useState(v4());

  const value = {
    opened,
    open: () => {
      const newFlowId = v4();
      Mixpanel.track(MixpanelEvents.SUITABILITY_REPORT_FLOW_STARTED, {
        flowId: newFlowId,
      });
      setFlowId(newFlowId);
      open();
    },
    close,
    flowId,
  };

  return (
    <SuitabilityContext value={value}>
      {children}
      <SuitabilityFlow opened={opened} close={close} flowId={flowId} />
    </SuitabilityContext>
  );
}
